<template>
  <div class="kk-page-impressum">
    <nav class="kk-page-impressum__nav">
      <ul class="kk-page-impressum__nav--items">
        <li class="item">
          <router-link to="/">
            <img :src="require('@/assets/kyra-logo.svg')" alt="Kyra Logo" />
          </router-link>
        </li>
        <li class="item">
          <language color="#92a3ab" />
        </li>
        <li class="item">
          <a href="https://www.kern.ag/de/kontakt/kontaktanfrage" class="kk-btn kk-btn__contact">
            {{ $t("impressumPage.contact") }}
          </a>
        </li>
        <li class="item">
          <router-link v-if="authState == 'signed-in'" to="/designs" class="kk-btn kk-btn__designs-btn">
            <span>{{ $t("homePage.processDesigns") }}</span>
          </router-link>
          <router-link v-else to="/signin" class="kk-btn kk-btn__login-btn">
            <span>{{ $t("impressumPage.signIn") }}</span>
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="kk-page-impressum__content">
      <h1>{{ $t("impressumPage.title") }}</h1>
      <hr class="hr" />
      <div class="kk-page-impressum__row">
        <div class="kk-page-impressum__row--col">
          <h2>{{ $t("impressumPage.address") }}</h2>
          <ul class="items">
            <li class="item">Kern Aktiengesellschaft</li>
            <li class="item">Heinrich-von-Stephan-Straße 15</li>
            <li class="item">79100 Freiburg im Breisgau</li>
          </ul>
        </div>
        <div class="kk-page-impressum__row--col">
          <h2>{{ $t("impressumPage.contact") }}</h2>
          <ul class="items">
            <li class="item">{{ $t("impressumPage.phone") }}: +49 (761) 791 878-0</li>
            <li class="item">Fax: +49 (761) 791 878-9</li>
            <li class="item">info@kern.ag</li>
            <li class="item">
              <a href="https://www.kern.ag/de" class="kk-link">www.kern.ag</a>
            </li>
          </ul>
        </div>
        <div class="kk-page-impressum__row--col">
          <h2>{{ $t("impressumPage.moreInfo") }}</h2>
          <ul class="items">
            <li class="item">{{ $t("impressumPage.chairman") }}: Eckhard Moos (Vors.), Christian Bieber</li>
            <li class="item">{{ $t("impressumPage.register") }}: Amtsgericht Freiburg HRB 6021</li>
            <li class="item">{{ $t("impressumPage.taxId") }}: DE203489656</li>
          </ul>
        </div>
      </div>
      <hr />
      <div class="kk-page-impressum__fulltext">
        <h2>{{ $t("impressumPage.disclaimer") }}</h2>
        <p>
          {{ $t("impressumPage.disclaimerMessage") }}
        </p>
      </div>
    </div>
    <footer class="kk-page-impressum__footer">
      <ul class="kk-page-impressum__footer--items">
        <li class="item">
          <a href="https://www.kern.ag/de" class="kk-link"> Kern AG </a>
        </li>
        <li class="item">
          <router-link to="/impressum" class="kk-link"> {{ $t("impressumPage.disclosure") }} </router-link>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import Language from "../components/navbar/Language.vue";
export default {
  components: { Language },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables";

.kk-page-impressum {
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  width: 100vw;
  margin: -0.5rem;
  background-color: white;
  background-image: url("../assets/bg.svg");
  background-size: contain;
  background-position: right;
  padding: 0 8rem;

  &__nav {
    padding-top: 1rem;
    padding-bottom: 2rem;
    &--items {
      list-style-type: none;
      display: flex;
      align-items: center;
      .item {
        &:first-child {
          flex-grow: 1;
        }
        img {
          width: 10rem;
          margin-left: -1.4rem;
        }
        .kk-btn {
          padding: 0.4rem 1.5rem;
          border-radius: @kk-border-radius;
          text-decoration: none;
          font-weight: 600;
          color: #92a3ab;
          transition: all 0.3s;
          &__contact {
            margin-right: 0.5rem;
            &:hover {
              outline: 1px solid @kk-color-primary-blue;
              box-shadow: @kk-color-primary-blue 0px 10px 15px -10px;
            }
          }
          &__login-btn,
          &__designs-btn {
            background: #d76fff;
            color: white;
            &:hover {
              box-shadow: @kk-color-primary-blue 0px 10px 15px -10px;
            }
          }
        }
      }
    }
  }
  &__content {
    flex-grow: 1;
    color: @kk-color-gray;
    .hr {
      margin-bottom: 1rem;
    }
    h1 {
      margin-bottom: 1rem;
    }
  }
  &__row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    color: @kk-color-gray;
    &--col {
      flex-basis: 32%;
      .items {
        list-style-type: none;
        .item {
          margin-left: -1.5rem;
          padding: 0;
          a {
            text-decoration: none;
            color: @kk-color-gray;
          }
        }
      }
    }
  }
  &__fulltext {
    margin-top: 1rem;
    color: @kk-color-gray;
  }
  &__footer {
    width: 100vw;
    margin-left: -8rem;
    padding: 1rem 8rem;
    background-color: @kk-color-primary-blue;
    color: white;
    &--items {
      list-style-type: none;
      margin-left: -1.4rem;
      .item {
        &:first-child {
          font-weight: 600;
        }
        .kk-link {
          text-decoration: none;
          color: white;
        }
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  .kk-page-impressum {
    width: 100vw;
    height: 100vh;
    padding: 0 1rem;
    background-size: cover;
    &__row {
      flex-direction: column;
      &--col {
        margin-bottom: 1rem;
      }
    }
    &__footer {
      width: calc(100vw + 7rem);
      margin-left: -2rem;
      padding: 2rem 2rem;
    }
  }
}

@media only screen and (max-width: 900px) {
  .kk-page-impressum {
    width: 100vw;
    height: 100vh;
    padding: 0 4rem;
    background-size: cover;
    &__row {
      flex-direction: column;
      &--col {
        margin-bottom: 1rem;
      }
    }
    &__footer {
      margin-left: -4rem;
      padding: 1rem 4rem;
    }
  }
}
</style>
